import React from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from 'reactstrap';
import style from './index.scss';

/**
 * AnomalyDispositionWidget
 */
export class AnomalyDispositionWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      selectedText: ''
    };
  }

  /**
   * componentWillReceiveProps
   * @param nextProps
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps?.headerAlertDetailObject && nextProps.permissionConfig) {
      const { investigation_result } = nextProps.headerAlertDetailObject;
      let iR = '';
      switch (investigation_result) {
        case 'STR':
          iR = 'Issue';
          break;
        case 'Non-STR':
          iR = 'No Issue';
          break;
        case 'Undetermined':
          iR = 'Insufficient Information';
          break;
        default:
          iR = investigation_result;
      }
      const { isDisabled, isReadOnly } = nextProps.permissionConfig || {};
      const selectedText = 'Select';
      if (isReadOnly || isDisabled) {
        this.setState({ selectedText: iR });
      } else {
        this.setState({ selectedText });
      }
    }
  }

  /**
   * onDropDownItemClick
   * @param e
   */
  onDropDownItemClick = (e) => {
    this.setState({ selectedText: e.target.innerText });
    this.props.onAnomalyResolutionSelection(e.target.innerText);
  };

  /**
   * setDropdownOpen
   */
  setDropdownOpen = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };
  /**
   * toggle
   */
  toggle = () => this.setDropdownOpen();

  /**
   * render func
   * @returns {*}
   */
  render() {
    const { selectedText } = this.state;
    const { permissionConfig } = this.props;
    const { isDisabled, isHidden, isReadOnly, isWrite } =
      permissionConfig || {};
    if (isHidden) {
      return <div />;
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <p className="mb-1">What is the result?</p>
        <div>
          {isWrite && (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
              <DropdownToggle className={style.dropDownToggleClass} caret>
                {selectedText}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={(e) => {
                    this.onDropDownItemClick(e);
                  }}>
                  Issue
                </DropdownItem>
                <DropdownItem
                  onClick={(e) => {
                    this.onDropDownItemClick(e);
                  }}>
                  No Issue
                </DropdownItem>
                <DropdownItem
                  onClick={(e) => {
                    this.onDropDownItemClick(e);
                  }}>
                  Insufficient Information
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          )}
          {(isReadOnly || isDisabled) && (
            <div className={style.disabledInvestigationResult}>
              {selectedText}
            </div>
          )}
        </div>
      </div>
    );
  }
}
